export enum I18nErrorMessage {
  INVALID_VALUE = 'Invalid value',
  REQUIRED = 'This field is required',
  MAX_REQUESTED_VALUE = 'The Requested Amount max',
  LICENSE_REMOVED = 'license policy has been removed from Cryptlex'
}

export enum TableActionMode {
  VIEW = 'view',
  EDIT = 'edit',
  DELETE = 'delete',
  SELECT_COUNTRY = 'selectCountry',
  ADD_RELEASE_NOTE = 'addReleaseNote',
  PUBLISH = 'publish',
  LINK = 'link',
  DEACTIVATE = 'deactivate'
}

export enum HttpStatus {
  OK = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  UNPROCESSABLE_ENTITY = 422,
  TOO_MANY_REQUESTS = 429,
  INTERNAL_SERVER_ERROR = 500,
  UNKNOWN_ERROR = 520
}

export enum Entity {
  RELEASE = 'Release',
  NOTIFICATION = 'Notification'
}

export enum Action {
  ADD = 'add',
  EDIT = 'edit',
  DELETE = 'delete',
  PUBLISH = 'publish',
  GET_DETAIL = 'getDetails'
}
